import { useEffect, useState } from 'react';
import Link from 'next/link';

export const PRIVACY_KEY = 'domstankov:privacy:v1';
export const CookieNotice = () => {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const reopen = () => setVisible(true);
    window.addEventListener('domstankov:privacy-settings', reopen);
    try {
      setVisible(!localStorage.getItem(PRIVACY_KEY));
    } catch {
      setVisible(true);
    }
    return () => window.removeEventListener('domstankov:privacy-settings', reopen);
  }, []);
  const choose = (choice: string) => {
    let previous: string | null = null;
    try {
      previous = localStorage.getItem(PRIVACY_KEY);
    } catch {}

    try {
      localStorage.setItem(PRIVACY_KEY, choice);
    } catch {}
    window.dispatchEvent(new Event('domstankov:privacy-change'));
    setVisible(false);
    if (choice === 'essential' && previous === 'all') {
      for (const cookie of document.cookie.split(';')) {
        const name = cookie.split('=')[0].trim();
        if (/^_ym_/.test(name))
          for (const domain of ['', location.hostname, '.' + location.hostname])
            document.cookie = name + '=; Max-Age=0; Path=/' + (domain ? '; Domain=' + domain : '');
      }
      location.reload();
    }
  };
  if (!visible) return null;
  return (
    <aside className="cookie-notice" aria-label="Настройки cookies">
      <p>
        Используем cookies для работы сайта. Аналитика — с вашего согласия.{' '}
        <Link href="/privacy-policy">Подробнее</Link>
      </p>
      <div>
        <button type="button" onClick={() => choose('all')}>
          Принять все
        </button>
        <button type="button" onClick={() => choose('essential')}>
          Только необходимые
        </button>
      </div>
    </aside>
  );
};
